import { useTranslation } from "react-i18next";
import { Modal, Button } from "../../shared-ui/primitives";
import type { ImportResult } from "../../lib/api-client/endpoints";

export function CatalogImportResultModal({ result, onClose }: { result: ImportResult; onClose: () => void }) {
  const { t } = useTranslation("masterData");
  return (
    <Modal
      open
      onOpenChange={(open) => !open && onClose()}
      title={t("importExport.importResult.title")}
      footer={
        <Button variant="primary" onClick={onClose}>
          {t("importExport.importResult.close")}
        </Button>
      }
    >
      <p>{t("importExport.importResult.created", { count: result.created })}</p>
      {result.skipped.length > 0 ? (
        <>
          <p>{t("importExport.importResult.skippedTitle", { count: result.skipped.length })}</p>
          <ul>
            {result.skipped.map((s) => (
              <li key={s.row}>{t("importExport.importResult.skippedRow", { row: s.row })}</li>
            ))}
          </ul>
        </>
      ) : null}
      {result.errors.length > 0 ? (
        <>
          <p>{t("importExport.importResult.errorsTitle", { count: result.errors.length })}</p>
          <ul>
            {result.errors.map((e) => (
              <li key={e.row}>{t("importExport.importResult.errorRow", { row: e.row, message: e.message })}</li>
            ))}
          </ul>
        </>
      ) : null}
    </Modal>
  );
}
